/**
 * Mirrors `VatLevels` in the backend (`api/models/types.ts:6-9`), which rejects any other
 * value with a 400 — keep the two in step, the backend is the authority.
 */
export const VatLevels = Object.freeze({
	"20": "20",
	"0": "0",
} as const)

export type VatLevel = (typeof VatLevels)[keyof typeof VatLevels]

export const vatLevelFor = (isVatable: unknown): VatLevel =>
	isVatable === true ? VatLevels["20"] : VatLevels["0"]
